import ModalDialog from 'components/ModalDialog';
import React from 'react';

import BPAFindingAgeHistoryTab from './BPAFindingAgeHistoryTab';
import { useBPAFindingAgeHistory } from '../../hooks/useBPAFindingAgeHistory';

interface BPAFindingAgeHistoryModalProps {
  companyId: number;
  findingId: number;
  findingTitle: string;
  onClose: () => void;
}

const BPAFindingAgeHistoryModal: React.FC<BPAFindingAgeHistoryModalProps> = ({
  companyId,
  findingId,
  findingTitle,
  onClose,
}) => {
  const ageHistory = useBPAFindingAgeHistory({
    companyId,
    enabled: true,
    findingId,
  });

  return (
    <ModalDialog
      title="Finding Age History"
      subTitle={findingTitle ? <p>{findingTitle}</p> : undefined}
      childComponent={
        <BPAFindingAgeHistoryTab
          error={ageHistory.error}
          isLoading={ageHistory.isLoading}
          items={ageHistory.items}
          onRetry={() => void ageHistory.retry()}
        />
      }
      onClose={onClose}
    />
  );
};

export default BPAFindingAgeHistoryModal;
